import { render, staticRenderFns } from "./EditarInsumo.vue?vue&type=template&id=45cf5f4b"
import script from "./EditarInsumo.vue?vue&type=script&lang=js"
export * from "./EditarInsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports